import React, { useState, useEffect, useMemo } from "react";
import Cookies from "universal-cookie";
import { useNavigate, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Preloading from "./Preload/Preloading";
import { toast } from "react-toastify";

import { useDispatch, useSelector } from "react-redux";

import Tooltip, { tooltipClasses } from "@mui/material/Tooltip";
import * as FaIcons from "react-icons/fa";
import * as BsIcons from "react-icons/bs";
import * as ImIcons from "react-icons/im";
import * as MdIcons from "react-icons/md";
import * as BiIocns from "react-icons/bi";
import * as GiIcons from "react-icons/gi";
import * as AiIcons from "react-icons/ai";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";

import { Outlet } from "react-router-dom";
import userTemImage from "../assets/img/user.jpg";

import AppsSharpIcon from "@mui/icons-material/AppsSharp";
import BookmarkAddedSharpIcon from "@mui/icons-material/BookmarkAddedSharp";
import AssignmentSharpIcon from "@mui/icons-material/AssignmentSharp";
import DashboardSharpIcon from "@mui/icons-material/DashboardSharp";
import BeenhereIcon from "@mui/icons-material/Beenhere";
import PeopleAltSharpIcon from "@mui/icons-material/PeopleAltSharp";
import SmsFailedSharpIcon from "@mui/icons-material/SmsFailedSharp";
import RedirectPages from "./RedirectPages/RedirectPages";
import host from "../assets/js/Host";
import Pusher from "pusher-js";
import feHost from "../assets/js/feHost";
import axios from "../assets/js/AxiosInterceptors";
import { setGlobalPathList } from "../reduxStore/SettingsReducer";
import { PanToolAlt } from "@mui/icons-material";
import { CgListTree } from "react-icons/cg";

const cookies = new Cookies();
Pusher.logToConsole = true;

export default function ProtectionAdmin(props) {
  let location = useLocation();
  const [t] = useTranslation("common");
  const token = cookies.get("token");
  const [hasAccessToThisRoute, setHasAccessToThisRoute] = useState(false);
  const [code, setCode] = useState(null);
  const [loading, setLoading] = useState(false);
  const [pathsList, setPathList] = useState([
    {
      id: 1,
      roles: (roles) => roles && roles?.includes(70),
      name: "Dashboard",
      to: "Dashboard",
      component: "",
      icon: (open) => (
        <Tooltip
          arrow
          placement="right"
          title={
            !open ? (
              <span style={{ fontFamily: "Cairo-Medium" }}>{"Dashboard"}</span>
            ) : (
              ""
            )
          }
        >
          <DashboardSharpIcon className="iconSideMenu" />
        </Tooltip>
      ),
      subLink: [],
    },
    {
      id: 2,
      roles: (roles) => roles && roles?.includes(71),
      name: "Users",
      to: "Users",
      component: "",
      icon: (open) => (
        <Tooltip
          arrow
          placement="right"
          title={
            !open ? (
              <span style={{ fontFamily: "Cairo-Medium" }}>{"Users"}</span>
            ) : (
              ""
            )
          }
        >
          <PeopleAltSharpIcon className="iconSideMenu" />
        </Tooltip>
      ),
      subLink: [],
    },
    {
      id: 3,
      roles: (roles) => roles && roles?.includes(72),
      name: "Department",
      to: "Department",
      component: "",
      icon: (open) => (
        <Tooltip
          arrow
          placement="right"
          title={
            !open ? (
              <span style={{ fontFamily: "Cairo-Medium" }}>{"Department"}</span>
            ) : (
              ""
            )
          }
        >
          <AppsSharpIcon className="iconSideMenu" />
        </Tooltip>
      ),
      subLink: [],
    },
    {
      id: 4,
      roles: (roles) => roles && roles?.includes(29),
      name: "Complain",
      to: "complain",
      component: "",
      icon: (open) => (
        <Tooltip
          arrow
          placement="right"
          title={
            !open ? (
              <span style={{ fontFamily: "Cairo-Medium" }}>{"Complain"}</span>
            ) : (
              ""
            )
          }
        >
          <SmsFailedSharpIcon className="iconSideMenu" />
        </Tooltip>
      ),
      subLink: [],
    },
    {
      id: 5,
      roles: (roles) => roles && roles?.includes(11),
      name: "Task Type",
      to: "Task_type",
      component: "",
      icon: (open) => (
        <Tooltip
          arrow
          placement="right"
          title={
            !open ? (
              <span style={{ fontFamily: "Cairo-Medium" }}>{"Task Type"}</span>
            ) : (
              ""
            )
          }
        >
          <BookmarkAddedSharpIcon className="iconSideMenu" />
        </Tooltip>
      ),
      subLink: [],
    },
    {
      id: 6,
      roles: (roles) => true,
      name: "Installation",
      to: "Installation",
      component: "",
      subLink: [],
    },
    {
      id: 7,
      roles: (roles) => roles && roles?.includes(73),
      name: "Mizan List Status",
      to: "mizan_list_status",
      component: "",
      icon: (open) => (
        <Tooltip
          arrow
          placement="right"
          title={
            !open ? (
              <span style={{ fontFamily: "Cairo-Medium" }}>
                {"Mizan List Status"}
              </span>
            ) : (
              ""
            )
          }
        >
          <FaIcons.FaWeight className="iconSideMenu" />
        </Tooltip>
      ),
      subLink: [],
    },
    {
      id: 8,
      roles: (roles) => roles && roles?.includes(27),
      name: "Drag And Drop Missions",
      to: "dnd_missions",
      component: "",
      icon: (open) => (
        <Tooltip
          arrow
          placement="right"
          title={
            !open ? (
              <span style={{ fontFamily: "Cairo-Medium" }}>{"Drag And Drop Missions"}</span>
            ) : (
              ""
            )
          }
        >
          <PanToolAlt />
        </Tooltip>
      ),
      subLink: [],
    },
    {
      id: 9,
      roles: (roles) => true,
      name: "Welcome Page",
      to: "welcome_page",
      component: "",
      // icon: (open) => (
      //   <Tooltip
      //     arrow
      //     placement="right"
      //     title={
      //       !open ? (
      //         <span style={{ fontFamily: "Cairo-Medium" }}>
      //           {"Mizan List Status"}
      //         </span>
      //       ) : (
      //         ""
      //       )
      //     }
      //   >
      //     <FaIcons.FaWeight className="iconSideMenu" />
      //   </Tooltip>
      // ),
      subLink: [],
    },
    {
      id: 10,
      roles: (roles) => roles && roles?.includes(36),
      name: "Missions",
      to: "missions",
      component: "",
      icon: (open) => (
        <Tooltip
          arrow
          placement="right"
          title={
            !open ? (
              <span style={{ fontFamily: "Cairo-Medium" }}>{"Missions"}</span>
            ) : (
              ""
            )
          }
        >
          <AssignmentSharpIcon className="iconSideMenu" />
        </Tooltip>
      ),
      subLink: [],
    },
    {
      id: 11,
      roles: (roles) => roles && roles?.includes(79),
      name: "General Tasks",
      to: "general_tasks",
      component: "",
      icon: (open) => (
        <Tooltip
          arrow
          placement="right"
          title={
            !open ? (
              <span style={{ fontFamily: "Cairo-Medium" }}>
                {"General Tasks"}
              </span>
            ) : (
              ""
            )
          }
        >
          <MdIcons.MdApps className="iconSideMenu" />
        </Tooltip>
      ),
      subLink: [],
    },
    {
      id: 12,
      roles: (roles) => roles && roles?.includes(80),
      name: "Installation Tasks",
      to: "installation_tasks",
      component: "",
      icon: (open) => (
        <Tooltip
          arrow
          placement="right"
          title={
            !open ? (
              <span style={{ fontFamily: "Cairo-Medium" }}>
                {"Installation Tasks"}
              </span>
            ) : (
              ""
            )
          }
        >
          <GiIcons.GiGearHammer className="iconSideMenu" />
        </Tooltip>
      ),
      subLink: [],
    },
    {
      id: 13,
      roles: (roles) => roles && roles?.includes(81),
      name: "Customer Care Tasks",
      to: "customer_care_tasks",
      component: "",
      icon: (open) => (
        <Tooltip
          arrow
          placement="right"
          title={
            !open ? (
              <span style={{ fontFamily: "Cairo-Medium" }}>
                {"Customer Care Tasks"}
              </span>
            ) : (
              ""
            )
          }
        >
          <MdIcons.MdOutlineHeadsetMic className="iconSideMenu" />
        </Tooltip>
      ),
      subLink: [],
    },
    // {
    //   id: 13,
    //   roles: (roles) => true,
    //   name: "Archived Tasks",
    //   to: "Tasks",
    //   component: "",
    //   icon: (open) => (
    //     <Tooltip
    //       arrow
    //       placement="right"
    //       title={
    //         !open ? (
    //           <span style={{ fontFamily: "Cairo-Medium" }}>
    //             {"Archived Tasks"}
    //           </span>
    //         ) : (
    //           ""
    //         )
    //       }
    //     >
    //       <AiIcons.AiOutlineFileZip className="iconSideMenu" />
    //     </Tooltip>
    //   ),
    //   subLink: [],
    // },
    {
      id: 14,
      roles: (roles) => roles && roles?.includes(27),
      name: "Unavailable Resources",
      to: "unavailable_resources",
      component: "",
      icon: (open) => (
        <Tooltip
          arrow
          placement="right"
          title={
            !open ? (
              <span style={{ fontFamily: "Cairo-Medium" }}>
                {"Unavailable Resources"}
              </span>
            ) : (
              ""
            )
          }
        >
          <BsIcons.BsShieldSlash className="iconSideMenu" />
        </Tooltip>
      ),
      subLink: [],
    },
    {
      id: 16,
      roles: (roles) => roles && roles?.includes(27),
      name: "Create Mission",
      to: "create_mission",
      component: "",
      icon: (open) => (
        <Tooltip
          arrow
          placement="right"
          title={
            !open ? (
              <span style={{ fontFamily: "Cairo-Medium" }}>
                {"Create Mission"}
              </span>
            ) : (
              ""
            )
          }
        >
          <AiIcons.AiOutlineAppstoreAdd className="iconSideMenu" />
        </Tooltip>
      ),
      subLink: [],
    },
    {
      id: 17,
      roles: (roles) => roles && roles?.includes(27),
      name: "Daily Plan",
      to: "daily_plan",
      component: "",
      icon: (open) => (
        <Tooltip
          arrow
          placement="right"
          title={
            !open ? (
              <span style={{ fontFamily: "Cairo-Medium" }}>{"Daily Plan"}</span>
            ) : (
              ""
            )
          }
        >
          <AiIcons.AiOutlineLineChart className="iconSideMenu" />
        </Tooltip>
      ),
      subLink: [],
    },
    {
      id: 19,
      roles: (roles) => roles && roles?.includes(30),
      name: "Request Types",
      to: "request_types",
      component: "",
      icon: (open) => (
        <Tooltip
          arrow
          placement="right"
          title={
            !open ? (
              <span style={{ fontFamily: "Cairo-Medium" }}>Request Types</span>
            ) : (
              ""
            )
          }
        >
          <BsIcons.BsCollectionFill className="iconSideMenu" />
        </Tooltip>
      ),
      subLink: [],
    },
    {
      id: 21,
      roles: (roles) => roles && roles?.includes(94),
      name: "Default Settings",
      to: "default_settings",
      component: "",
      icon: (open) => (
        <Tooltip
          arrow
          placement="right"
          title={
            !open ? (
              <span style={{ fontFamily: "Cairo-Medium" }}>
                Default Settings
              </span>
            ) : (
              ""
            )
          }
        >
          <AiIcons.AiOutlineStar className="iconSideMenu" />
        </Tooltip>
      ),
      subLink: [],
    },
    {
      id: 22,
      roles: (roles) => true,
      name: "Customers",
      to: "/customers",
      component: "",
      subLink: [],
    },
    {
      id: 23,
      roles: (roles) => roles && roles?.includes(74),
      name: "Notifications",
      to: "Notifications",
      component: "",
      subLink: [],
    },
    {
      id: 23,
      roles: (roles) => roles && roles?.includes(74),
      name: "Transfer Notification",
      to: "transfer_notification",
      component: "",
      subLink: [],
    },
    {
      id: 24,
      roles: (roles) => true,
      name: "NoteTask",
      to: "NoteTask",
      component: "",
      subLink: [],
    },
    {
      id: 25,
      roles: (roles) => true,
      name: "LogTable",
      to: "LogTable",
      component: "",
      subLink: [],
    },
    {
      id: 26,
      roles: (roles) => true,
      name: "Detials TaskEdit",
      to: "Detials_TaskEdit",
      component: "",
      subLink: [],
    },
    {
      id: 27,
      roles: (roles) => true,
      name: "mission details",
      to: "mission_details",
      component: "",
      subLink: [],
    },
    {
      id: 28,
      roles: (roles) => true,
      name: "view_task",
      to: "view_task",
      component: "",
      subLink: [],
    },
    {
      id: 33,
      roles: (roles) => roles?.includes(33),
      name: "Task Summary Dashboard",
      to: "task_summary_dashboard",
      component: "",
      subLink: [],
    },
    {
      id: 32,
      roles: (roles) => roles && roles?.includes(32),
      name: "Customer Care Report",
      to: "customer_care_reports",
      component: "",
      subLink: [],
    },
    {
      id: 33,
      roles: (roles) => true,
      name: "User Profile",
      to: "user-profile",
      component: "",
      subLink: [],
    },
    {
      id: 34,
      roles: (roles) => roles && roles?.includes(51),
      name: "Leave Requests",
      to: "leave-requests",
      component: "",
      subLink: [],
    },
    {
      id: 35,
      roles: (roles) => roles && roles?.includes(54),
      name: "Inventory Requests",
      to: "inventory-requests",
      component: "",
      subLink: [],
    },
    {
      id: 36,
      roles: (roles) => roles && roles?.includes(60),
      name: "User OverTimes",
      to: "user-overtimes",
      component: "",
      subLink: [],
    },
    {
      id: 37,
      roles: (roles) => roles && roles?.includes(75),
      name: "SubMission OverTimes",
      to: "sub-mission-overtimes",
      component: "",
      subLink: [],
    },
    {
      id: 38,
      roles: (roles) => true,
      name: "New Ticket View",
      to: "new-ticket-view",
      component: "",
      subLink: [],
    },
    {
      id: 64,
      roles: (roles) => roles && roles?.includes(64),
      name: "Files",
      to: "files",
      component: "",
      subLink: [],
    },
    {
      id: 65,
      roles: (roles) => roles && roles?.includes(68),
      name: "Classifications",
      to: "classifications",
      component: "",
      subLink: [],
    },
    {
      id: 66,
      roles: (roles) => roles && roles?.includes(68),
      name: "Classifications Level 1",
      to: "classifications-level-1",
      component: "",
      subLink: [],
    },
    {
      id: 67,
      roles: (roles) => roles && roles?.includes(68),
      name: "Classifications Level 2",
      to: "classifications-level-2",
      component: "",
      subLink: [],
    },
    {
      id: 68,
      roles: (roles) => roles && roles?.includes(68),
      name: "Classifications Level 3",
      to: "classifications-level-3",
      component: "",
      subLink: [],
    },
    {
      id: 69,
      roles: (roles) => roles && roles?.includes(68),
      name: "Classifications Level 4",
      to: "classifications-level-4",
      component: "",
      subLink: [],
    },
    {
      id: 70,
      roles: (roles) => roles && roles?.includes(82),
      name: "Vehicles Master",
      to: "vehicle_master",
      component: "",
      subLink: [],
    },
    {
      id: 71,
      roles: (roles) => roles && roles?.includes(68),
      name: "Classifications Tree View",
      to: "classifications-tree-view",
      component: "",
      subLink: [],
    },
    {
      id: 353,
      roles: (roles) => roles && roles?.includes(76),
      name: "Car Inspections",
      to: "car_inspections",
      component: "",
      subLink: [],
    },
    {
      id: 266666,
      roles: (roles) => roles && roles?.includes(77),
      name: "Inspection Categories",
      to: "car_inspections_categories",
    },
    {
      id: 366654,
      roles: (roles) => roles && roles?.includes(78),
      name: "Inspection Questions",
      to: "car_inspections_questions",
    },
    {
      id: 366655,
      roles: (roles) => roles && roles?.includes(86),
      name: "Groups",
      to: "groups",
    },
    {
      id: 366656,
      roles: (roles) => roles && roles?.includes(95),
      name: "Update Contents",
      to: "update-contents",
    },
    {
      id: 366657,
      roles: (roles) => roles && roles?.includes(97),
      name: "Link Images",
      to: "image-submission-type",
    },
    {
      id: 366658,
      roles: (roles) => roles && roles?.includes(99),
      name: "SUBM Image Types",
      to: "submission-image-types",
    },
    {
      id: 366659,
      roles: (roles) => roles && roles?.includes(100),
      name: "Submission Types",
      to: "submission-types",
    },
    {
      id: 366359,
      roles: (roles) => roles && roles?.includes(64),
      name: "File Manager",
      to: "file_manager",
    },
    {
      id: 72,
      roles: (roles) => roles && roles?.includes(79),
      name: "Finances",
      to: "finances",
    },
    {
      id: 73,
      roles: (roles) => roles && roles?.includes(11),
      name: "FinanceType",
      to: "finance_type",
    },
    {
      id: 74,
      roles: (roles) => roles && roles?.includes(11),
      name: "Finance Task Details",
      to: "financeTaskDetails",
    },
    {
      id: 75,
      roles: (roles) => roles && roles?.includes(79),
      name: "Units Transfer",
      to: "units_transfer",
    },
    {
      id: 76,
      roles: (roles) => roles && roles?.includes(72),
      name: "Attendances",
      to: "attendances",
    },
    {
      id: 77,
      roles: (roles) => roles && roles?.includes(106),
      name: "Warsha plans",
      to: "warsha_plans",
    },
  ]);

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(setGlobalPathList(pathsList))
  }, [pathsList])
  const checkTokenIsValid = async () => {
    let result = null;
    let jwt = cookies.get("token");
    let headers = {
      jwt: jwt,
      "Access-Control-Allow-Origin": "*",
      "Content-Type": "application/json",
    };
    try {
      result = await axios({
        url: host + "roles",
        headers: headers,
        method: "get",
      });
      if (result && !result?.data?.status) {
        if (
          result?.data?.data &&
          result?.data?.data?.message?.text &&
          result?.data?.data?.message?.text == "invalid token"
        ) {
          console.log("checkToken2");

          cookies.remove("username", { path: "/" });
          localStorage.removeItem("userData");
          cookies.remove("user_id", { path: "/" });
          localStorage.removeItem("roles");
          cookies.remove("token", token, {
            path: "/",
          });
          window.location.href = "/";
        }
      }
    } catch (error) {
      const responseResult = error.response;

      if (responseResult && responseResult.status === 401) {
        cookies.remove("username", { path: "/" });
        localStorage.removeItem("userData");
        cookies.remove("user_id", { path: "/" });
        localStorage.removeItem("roles");
        cookies.remove("token", token, {
          path: "/",
        });
        window.location.href = "/";
      }
    }
  };

  useEffect(() => {
    let abortController = new AbortController();
    console.log("sdfsdfsdfsdfsdf=>", location?.pathname);
    // checkTokenIsValid();
    routeChange();
    return () => {
      abortController.abort();
    };
  }, [location?.pathname]);

  const routeChange = async () => {
    setLoading(true);
    if (
      JSON.parse(localStorage.getItem("roles")) &&
      JSON.parse(localStorage.getItem("roles"))?.length > 0
    ) {
      let check = false;
      let codeError = null;
      pathsList &&
        pathsList?.length > 0 &&
        pathsList?.map((itm) => {
          if (!check) {
            if (location?.pathname == `/ticket-system/${itm?.to}`) {
              let checkIsInRole = false;
              if (
                itm?.roles(JSON.parse(localStorage.getItem("roles"))) == true
              ) {
                checkIsInRole = true;
              }
              if (checkIsInRole) {
                check = true;
              } else {
                check = false;
                codeError = 501;
              }
            } else {
              check = false;
              if (!codeError) codeError = 404;
            }
            // }
          }
        });
      if (check) {
        setHasAccessToThisRoute(true);
        console.log("enter success");
        setLoading(false);
      } else {
        setHasAccessToThisRoute(false);
        setLoading(false);
        setCode(codeError);
      }
    } else if (!loading) {
      setCode(503);
      setHasAccessToThisRoute(false);
      setLoading(false);
    }
    setLoading(false);
  };

  var timer;

  useEffect(() => {
    subscribeToNotifications();
    return () => {
      clearTimeout(timer);
    };
  }, []);
  const subscribeToNotifications = () => {
    if (!window?.pusher) {
      var pusher = null;
      window.pusher = pusher = new Pusher("9c36a8d1d324842389dd", {
        cluster: "ap1",
      });
      let currentNotification = null;
      subscibeToLeaveRequestNotification(pusher); //show notification for user that request leave request.
      subscibeToUserOverTImeNotification(pusher); //show notification for user that request leave request.
      subscribeToChangeSubmissionEngineerNotifications(pusher)
      if (JSON.parse(localStorage.getItem("roles"))?.includes(91)) {
        subscibeToExternalTaskRequestNotification(pusher); //show notification for external task request.
      }
      // if (JSON.parse(localStorage.getItem("roles"))?.includes(94)) {
      subscibeToTaskNotificationConfigurationRequestNotification(pusher); //show notification for any action on task.
      // }
      if (JSON.parse(localStorage.getItem("roles"))?.includes(37)) {
        const submissionNotificationChannel = pusher.subscribe(
          "submissions_notifications"
        );
        submissionNotificationChannel.bind("submission_updated", (data) => {
          if (!currentNotification || currentNotification != data?.id) {
            if (
              cookies.get("user_id") == data?.eng_id &&
              data?.channelBrodcast == 1
            ) {
              if ("Notification" in window) {
                // Notification API is supported
                if (Notification.permission === "granted") {
                  const notification = new Notification("اشعار تحديث مهمة", {
                    body: data?.title,
                    icon: require("../assets/img/Logo.png").default,
                    data: {
                      url: feHost + `mission_details?id=${data?.mission_id}`,
                    },
                  });
                  notification.onclick = function (event) {
                    event.preventDefault();
                    window.focus();
                    const url = event.target.data.url;
                    window.open(url, "_blank");
                  };
                } else {
                  Notification.requestPermission().then(function (permission) {
                    if (permission === "granted") {
                      // User has granted permission
                      const notification = new Notification("اشعار تحديث مهمة", {
                        body: data?.title,
                        icon: require("../assets/img/Logo.png").default,
                        data: {
                          url: feHost + `mission_details?id=${data?.mission_id}`,
                        },
                      });
                      notification.onclick = function (event) {
                        event.preventDefault();
                        window.focus();
                        const url = event.target.data.url;
                        window.open(url, "_blank");
                      };
                    }
                  });
                }
              }
              let titleText = data?.title && data?.title?.length > 45 ? (data?.title?.slice(0, 45) + '...') : data?.title
              toast.info(titleText, {
                position: "bottom-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "dark",
                toastId: data?.id,
                style: {
                  maxWidth: '200px',
                  backgroundColor: '#000000a0'
                },
                bodyStyle: {
                  wordBreak: 'break-word',
                }
              });
            }

            currentNotification = data?.id;
          }
        });
      }
    }
  };
  // var subscribeToNotificationsChannel=false
  const subscibeToLeaveRequestNotification = (pusher) => {
    if (!cookies.get("user_id")) {
      toast.warn("No user Id,you must login again");
      if (cookies.get('token')) {
        cookies.remove('token')
        window.location.href = '/'
      }
      return false;
    }

    // if(subscribeToNotificationsChannel){
    //   return false;
    // }
    const channleName = "leave_request_user_notification";
    const eventName = "leaveRequest_updated";

    const leaveRequestNotificationChannel = pusher.subscribe(channleName);
    // subscribeToNotificationsChannel=true
    leaveRequestNotificationChannel.bind(eventName, (data) => {
      if (
        data?.channelBrodcast == 2 &&
        data?.user_id == cookies.get("user_id") &&
        ((data?.is_supervisor &&
          JSON.parse(localStorage.getItem("roles")) &&
          JSON.parse(localStorage.getItem("roles")).includes(50)) ||
          data?.is_supervisor == false)
      ) {
        const title = data?.is_supervisor
          ? `${data?.employee_name} send you request for leave Request`
          : "Your Leave Request Has been " +
          data?.status_name +
          " by Supervisor : " +
          data?.supervisor_name;
        if ("Notification" in window) {
          // Notification API is supported
          if (Notification.permission === "granted") {
            const notification = new Notification("اشعار طلب اجازة", {
              body: title,
              icon: require("../assets/img/Logo.png").default,
              data: { url: feHost + `leave-requests?id=${data?.id}` },
            });
            notification.onclick = function (event) {
              event.preventDefault();
              window.focus();
              const url = event.target.data.url;
              window.open(url, "_blank");
            };
          } else {
            Notification.requestPermission().then(function (permission) {
              if (permission === "granted") {
                // User has granted permission
                const notification = new Notification("اشعار طلب اجازة", {
                  body: title,
                  icon: require("../assets/img/Logo.png").default,
                  data: { url: feHost + `leave-requests?id=${data?.id}` },
                });
                notification.onclick = function (event) {
                  event.preventDefault();
                  window.focus();
                  const url = event.target.data.url;
                  window.open(url, "_blank");
                };
              }
            });
          }
        }
        let titleText = title && title?.length > 45 ? (title?.slice(0, 45) + '...') : title
        toast.info(titleText, {
          position: "bottom-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "dark",
          toastId: data?.id,
        });
      }
    });
  };
  const subscibeToUserOverTImeNotification = (pusher) => {
    if (!cookies.get("user_id")) {
      toast.warn("you must login again");
      return false;
    }

    // if(subscribeToNotificationsChannel){
    //   return false;
    // }
    const channelName = `user_overtime_notification`;
    const eventName = "userOverTime_updated";
    const leaveRequestNotificationChannel = pusher.subscribe(channelName);
    // subscribeToNotificationsChannel=true
    leaveRequestNotificationChannel.bind(eventName, (data) => {
      if (
        data?.channelBrodcast == 3 &&
        data?.user_id == cookies.get("user_id") &&
        ((data?.is_supervisor &&
          JSON.parse(localStorage.getItem("roles")) &&
          JSON.parse(localStorage.getItem("roles")).includes(59)) ||
          data?.is_supervisor == false)
      ) {
        const title = data?.is_supervisor
          ? `${data?.employee_name} send you request for overTime`
          : "Your overtime Has been " +
          data?.status_name +
          " by Supervisor : " +
          data?.supervisor_name;
        if ("Notification" in window) {
          // Notification API is supported
          if (Notification.permission === "granted") {
            const notification = new Notification("اشعار عمل اضافي", {
              body: title,
              icon: require("../assets/img/Logo.png").default,
              data: { url: feHost + `user-overtimes?id=${data?.id}` },
            });
            notification.onclick = function (event) {
              event.preventDefault();
              window.focus();
              const url = event.target.data.url;
              window.open(url, "_blank");
            };
          } else {
            Notification.requestPermission().then(function (permission) {
              if (permission === "granted") {
                // User has granted permission
                const notification = new Notification("اشعار عمل اضافي", {
                  body: title,
                  icon: require("../assets/img/Logo.png").default,
                  data: { url: feHost + `user-overtimes?id=${data?.id}` },
                });
                notification.onclick = function (event) {
                  event.preventDefault();
                  window.focus();
                  const url = event.target.data.url;
                  window.open(url, "_blank");
                };
              }
            });
          }
        }
        let titleText = title && title?.length > 45 ? (title?.slice(0, 45) + '...') : title
        toast.info(titleText, {
          position: "bottom-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "dark",
          toastId: data?.id,
        });
      }
    });
  };
  const subscibeToExternalTaskRequestNotification = (pusher) => {
    if (!cookies.get("user_id")) {
      toast.warn("you must login again");
      return false;
    }
    const channelName = `external_task_request_notification`;
    const eventName = "externalTaskRequest_create";
    const externalTaskRequestNotificationChannel = pusher.subscribe(channelName);
    externalTaskRequestNotificationChannel.bind(eventName, (data) => {
      if (
        data?.channelBrodcast == 4
      ) {
        const title = "New Customer Request created by " + data?.external_user_name;
        if ("Notification" in window) {
          // Notification API is supported
          if (Notification.permission === "granted") {
            const notification = new Notification("اشعار طلب مهمة من قبل زبون", {
              body: title,
              icon: require("../assets/img/Logo.png").default,
              data: { url: feHost + `Detials_TaskEdit?id=${data?.id}` },
            });
            notification.onclick = function (event) {
              event.preventDefault();
              window.focus();
              const url = event.target.data.url;
              window.open(url, "_blank");
            };
          } else {
            Notification.requestPermission().then(function (permission) {
              if (permission === "granted") {
                // User has granted permission
                const notification = new Notification("اشعار طلب مهمة من قبل زبون", {
                  body: title,
                  icon: require("../assets/img/Logo.png").default,
                  data: { url: feHost + `Detials_TaskEdit?id=${data?.id}` },
                });
                notification.onclick = function (event) {
                  event.preventDefault();
                  window.focus();
                  const url = event.target.data.url;
                  window.open(url, "_blank");
                };
              }
            });
          }
        }
        let titleText = title && title?.length > 45 ? (title?.slice(0, 45) + '...') : title
        toast.info(titleText, {
          position: "bottom-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "dark",
          toastId: data?.id,
        });
      }
    });
  };
  const subscibeToTaskNotificationConfigurationRequestNotification = (pusher) => {
    if (!cookies.get("user_id")) {
      toast.warn("you must login again");
      return false;
    }
    const channelName = `task_notification_configuration`;
    const eventName = 'task_notification_configuration_create'
    const externalTaskRequestNotificationChannel = pusher.subscribe(channelName);
    externalTaskRequestNotificationChannel.bind(eventName, (data) => {
      console.log('asdasdasdasdasdasdasdasdasdsadasd---->', data?.user_ids)
      console.log('asdasdasdasdasdasdasdasdasdsadasd---->1', data?.channelBrodcast == 5)
      console.log('asdasdasdasdasdasdasdasdasdsadasd---->2', data?.user_ids?.length)
      console.log('asdasdasdasdasdasdasdasdasdsadasd---->3', cookies.get("user_id"))
      console.log('asdasdasdasdasdasdasdasdasdsadasd---->4', data?.user_ids?.find(itm => itm == cookies.get("user_id")))
      if (
        data?.channelBrodcast == 5 &&
        data?.user_ids && data?.user_ids?.length &&
        data?.user_ids?.find(itm => itm == cookies.get("user_id"))
      ) {

        const title = data?.title;
        if ("Notification" in window) {
          // Notification API is supported
          if (Notification.permission === "granted") {
            const notification = new Notification(data?.name, {
              body: title,
              icon: require("../assets/img/Logo.png").default,
              data: { url: feHost + `Detials_TaskEdit?id=${data?.task_id}` },
            });
            notification.onclick = function (event) {
              event.preventDefault();
              window.focus();
              const url = event.target.data.url;
              window.open(url, "_blank");
            };
          } else {
            Notification.requestPermission().then(function (permission) {
              if (permission === "granted") {
                // User has granted permission
                const notification = new Notification(data?.name, {
                  body: title,
                  icon: require("../assets/img/Logo.png").default,
                  data: { url: feHost + `Detials_TaskEdit?id=${data?.task_id}` },
                });
                notification.onclick = function (event) {
                  event.preventDefault();
                  window.focus();
                  const url = event.target.data.url;
                  window.open(url, "_blank");
                };
              }
            });
          }
        }
        let titleText = title && title?.length > 45 ? (title?.slice(0, 45) + '...') : title
        toast.info(titleText, {
          position: "bottom-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "dark",
          toastId: data?.id,
        });
      }
    });
  };
  const subscribeToChangeSubmissionEngineerNotifications = (pusher) => {
    if (!cookies.get("user_id")) {
      toast.warn("you must login again");
      return false;
    }
    const current_user_id = cookies.get("user_id");
    const channelName = `change_submission_engineer_notification_configuration`;
    const eventName = 'change_submission_engineer_notification_configuration_create'
    const externalTaskRequestNotificationChannel = pusher.subscribe(channelName);
    externalTaskRequestNotificationChannel.bind(eventName, (data) => {
      if (
        data?.channelBrodcast == 6 && (
          (
            data?.from_user_id && data?.from_user_id == current_user_id ||
            data?.to_user_id && data?.to_user_id == current_user_id
          )
          ||
          (localStorage.getItem('roles')&&JSON.parse(localStorage.getItem('roles'))?.includes(98))
        )
      ) {

        const title = data?.title;
        if ("Notification" in window) {
          // Notification API is supported
          if (Notification.permission === "granted") {
            const notification = new Notification(data?.name, {
              body: title,
              icon: require("../assets/img/Logo.png").default,
              data: { url: feHost + `mission_details?id=${data?.mission_id}&subId=${data?.id}` },
            });
            notification.onclick = function (event) {
              event.preventDefault();
              window.focus();
              const url = event.target.data.url;
              window.open(url, "_blank");
            };
          } else {
            Notification.requestPermission().then(function (permission) {
              if (permission === "granted") {
                // User has granted permission
                const notification = new Notification(data?.name, {
                  body: title,
                  icon: require("../assets/img/Logo.png").default,
                  data: { url: feHost + `mission_details?id=${data?.mission_id}&subId=${data?.id}` },
                });
                notification.onclick = function (event) {
                  event.preventDefault();
                  window.focus();
                  const url = event.target.data.url;
                  window.open(url, "_blank");
                };
              }
            });
          }
        }
        let titleText = title && title?.length > 45 ? (title?.slice(0, 45) + '...') : title
        toast.info(titleText, {
          position: "bottom-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "dark",
          toastId: data?.id,
        });
      }
    });
  };

  if (!loading) {
    if (hasAccessToThisRoute && token) {
      return props?.children
    } else {
      if (code === 404)
        return (
          <RedirectPages
            code={code}
            reason={"Woobs!"}
            message="The page you are looking for is not currently available"
            path={"/ticket-system/Dashboard"}
            goTo="Go Home"
          />
        );
      else if (code === 501)
        return (
          <RedirectPages
            code={code}
            reason={"Woobs!"}
            message="You don't have permission to access this page"
            path={"/ticket-system/Dashboard"}
            goTo="Go Home"
          />
        );
      else if (code === 503)
        return (
          <RedirectPages
            code={code}
            reason={"Woobs!"}
            message="There is a trouble with the server"
            path={"/ticket-system/Dashboard"}
            goTo="Reload Page"
            hasReload={true}
          />
        );
      else if (!token) {

        if (cookies.get('username'))
          cookies.remove("username");

        if (localStorage.getItem('userData'))
          localStorage.removeItem("userData");

        if (cookies.get('user_id'))
          cookies.remove("user_id");

        if (localStorage.getItem('roles'))
          localStorage.removeItem("roles");

        if (cookies.get('token'))
          cookies.remove("token");

        window.location.href = "/";
      }
    }
  } else {
    return <Preloading />;
  }
}
